// generated by the plop

export class GetClients {
  static type = '[client] GetClient';

  constructor(public phone: string) {
  }
}

export class GetStoryByClientId {
  static type = '[client] GetStoryByClientId';

  constructor(public id: string) {
  }
}

export class GetClientInfo {
  static type = '[client] GetClientInfo';

  constructor(public id: string) {
  }
}

export class GetClientInfoByToken {
  static type = '[client] GetClientInfoByToken';
}
